import { fileService } from '../../services';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ImageUploadRequestDTO, ImageUploadResponseDTO } from '../../dtos';
import { APIErrorMessage } from '../../../../../shared/infra/api/APIErrorMessage';
import { updateProgress } from '../Files.slice';
import { AxiosProgressEvent } from 'axios';

const uploadCoverImage = createAsyncThunk<
  ImageUploadResponseDTO,
  ImageUploadRequestDTO,
  {
    rejectValue: APIErrorMessage;
  }
>(
  'files/uploadCoverImage',
  async (uploadRequest, { dispatch, rejectWithValue }) => {
    const handleUploadProgress = (progressEvent: AxiosProgressEvent) => {
      const progressPercentage =
        progressEvent.total && progressEvent.total > 0
          ? Math.floor((progressEvent.loaded / progressEvent.total) * 100)
          : 0;
      dispatch(updateProgress(progressPercentage));
    };

    const result = await fileService.uploadCoverImage(
      uploadRequest,
      handleUploadProgress,
    );

    if (result.isLeft()) {
      const error = result.value;
      return rejectWithValue(error);
    } else {
      return result.value.getValue();
    }
  },
);

export default uploadCoverImage;
